import React from 'react';
import { Search, Plus, X, TrendingUp, TrendingDown, Loader2 } from 'lucide-react';
import Skeleton from '../common/Skeleton';
import { getCurrency } from '../../utils/helpers';

const SidebarContent = ({
  watchlist, selectedStock, setSelectedStock,
  showAddStock, setShowAddStock,
  searchTerm, setSearchTerm,
  searchResults, searchLoading,
  watchlistQuotes,
  addToWatchlist, removeFromWatchlist, onStockSelect
}) => (
  <div className="bg-surface backdrop-blur border border-brd-primary rounded-xl p-4">
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-semibold text-txt-primary">Watchlist</h2>
      <button onClick={() => setShowAddStock(!showAddStock)} className="p-2 hover:bg-elevated rounded-lg transition-colors text-txt-secondary"><Plus size={18} /></button>
    </div>
    {showAddStock && (
      <div className="mb-4">
        <div className="relative mb-2">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-txt-muted" size={16} />
          <input type="text" placeholder="Ticker o ISIN (es. AAPL, US0378331005)" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-elevated border border-brd-subtle rounded-lg pl-9 pr-4 py-2 text-sm text-txt-primary focus:outline-none focus:border-blue-500" />
        </div>
        <div className="max-h-48 overflow-y-auto space-y-1">
          {searchLoading && <div className="text-center py-2"><Loader2 size={16} className="animate-spin mx-auto text-txt-muted" /></div>}
          {searchResults.map((result) => (
            <button key={result.symbol} onClick={() => addToWatchlist(result.symbol)}
              className="w-full text-left px-3 py-2 hover:bg-elevated rounded-lg text-sm transition-colors min-h-[44px]">
              <div className="font-medium text-txt-primary">{result.symbol}</div>
              <div className="text-xs text-txt-secondary truncate">{result.description}</div>
              {result.isin && <div className="text-[10px] text-txt-muted font-mono">{result.isin}</div>}
            </button>
          ))}
          {searchTerm && !searchLoading && searchResults.length === 0 && <div className="text-xs text-txt-muted text-center py-2">Nessun risultato</div>}
        </div>
      </div>
    )}
    <div className="space-y-2">
      {watchlist.map(symbol => {
        const q = watchlistQuotes[symbol];
        return (
          <div key={symbol} onClick={() => { setSelectedStock(symbol); onStockSelect?.(); }}
            className={`p-3 rounded-lg cursor-pointer transition-all group min-h-[44px] ${selectedStock === symbol ? 'bg-blue-500/20 border border-blue-500' : 'bg-card border border-brd-subtle hover:bg-elevated'}`}>
            <div className="flex items-center justify-between mb-1">
              <span className="font-semibold text-sm text-txt-primary">{symbol}</span>
              <button onClick={(e) => { e.stopPropagation(); removeFromWatchlist(symbol); }} className="opacity-0 group-hover:opacity-100 p-1 hover:bg-red-500/20 rounded transition-all"><X size={14} /></button>
            </div>
            {q ? (
              <div className="flex items-center justify-between">
                <span className="font-bold text-sm text-txt-primary">{getCurrency(symbol)}{q.c?.toFixed(2)}</span>
                <div className={`flex items-center gap-1 text-xs ${q.d >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                  {q.d >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
                  {q.dp > 0 ? '+' : ''}{q.dp?.toFixed(2)}%
                </div>
              </div>
            ) : <Skeleton className="h-5 w-full" />}
          </div>
        );
      })}
    </div>
  </div>
);

const WatchlistSidebar = ({ isOpen, onClose, ...props }) => (
  <>
    {/* Desktop: inline sidebar */}
    <div className="hidden lg:block lg:col-span-1">
      <SidebarContent {...props} />
    </div>

    {/* Mobile: overlay drawer */}
    <div className={`lg:hidden fixed inset-0 z-50 transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      {/* Drawer panel */}
      <div className={`absolute top-0 left-0 h-full w-[280px] max-w-[80vw] p-4 overflow-y-auto transition-transform duration-300 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <SidebarContent {...props} onStockSelect={onClose} />
      </div>
    </div>
  </>
);

export default WatchlistSidebar;
